import { faTable } from '@fortawesome/free-solid-svg-icons';
import Input from '../../Common/Input/Input';
import Button from '../../Common/Button/Button';

/**
 * Search Bar Component for filtering tables
 */
const SearchBar = ({ 
  searchTerm, 
  onSearchChange, 
  onCreateTable, 
  canCreate = true,
  disabled = false 
}) => {
  return (
    <div className="eng-temp-search-bar">
      <Input
        type="text"
        placeholder="Search here ..."
        variant="search"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        disabled={disabled}
        className="eng-temp-search-bar__input"
      />
      {canCreate && !disabled && (
        <Button
          variant="primary"
          icon={faTable}
          onClick={onCreateTable}
          className="eng-temp-search-bar__button"
        >
          Create New Table
        </Button>
      )}
    </div>
  );
};

export default SearchBar;
